<template>
  <el-dialog
      :visible="isVisible"
      @close="hide"
      title="Filemaker import"
      :destroy-on-close="true"
  >
    <loading v-if="!isInitialized"></loading>
    <import-form
        v-if="isInitialized"
        v-bind="formData"
        @stored="onStored"
        :type="type"
    ></import-form>
  </el-dialog>
</template>

<script>
import BaseImportDialog from './base-import-dialog';
import ImportForm from '../../../components/import/forms/filemaker';
import Loading from '../../../components/loading';
import eventBus from '../../../event-bus';

export default {
  extends: BaseImportDialog,

  props: {
    type: Number,
  },

  components: {
    ImportForm,
    Loading,
  },

  created() {
    eventBus.$on('show-add-filemaker-import-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-add-filemaker-import-dialog', this.show);
  },
}
</script>
